"use strict";

define('config/routes',['require','exports','module','appkit/configurator','legacy.router','libs/route.helper'],function (require, exports, module) {
  var Configurator = require('appkit/configurator'),
    LegacyRouter = require('legacy.router'),
    RouteHelper = require('libs/route.helper');
  RouteConfigurator = Configurator.extend({
    onConfigure: function onConfigure() {
      var router = new LegacyRouter();
      router.route('*default', 'dashboard:index');
      router.route('dashboard', 'dashboard:index');
      router.route('study/:studyId', 'study:detail');
      router.route('study/create', 'study:create');
      router.route('study/:studyId/:documentId', 'submission:detail');
      router.route('submission/edit/:id(/)(section/:section)', 'submission:edit');
      router.route('submission/decision/:id(/:meetingId)', 'decision:make');
      router.route('submission/decision/history/:decisionId', 'decision:history');
      router.route('submission/:documentId/letters/list', 'submission:letters');
      router.route('submission/:documentId/letters/create', 'submission:letterCreate');
      router.route('submission/:documentId/letters/detail/:letterId', 'submission:letterDetail');
      router.route('submission/:documentId/meeting/detail/:meetingId', 'submission:meetingDetail');
      router.route('setup/assignment/:documentId', 'submission:assignments');
      router.route('study/list/:type(/*state)', 'study:list');
      RouteHelper.setDefaultParams('study:list', {
        type: 'active'
      });
      router.route('submission/list(/*state)', 'submission:list');
      router.route('task/list(/*state)', 'task:list');
      router.route('letter/template/list(/*state)', 'letterTemplate:list');
      router.route('letter/template/detail/:letterTemplateId', 'letterTemplate:detail');
      router.route('letter/template/create', 'letterTemplate:create');
      router.route('meeting/list(/:tab)(/:month/:year)(/:date)(/board/:boardId)', 'meeting:list');
      router.route('meeting/create(/:date)(/:boardId)', 'meeting:create');
      router.route('meeting/detail/:meetingId', 'meeting:detail');
      router.route('meeting/submission/:documentId', 'meeting:submission');
      router.route('report/list/:type(/*state)', 'reporting:list');
      RouteHelper.setDefaultParams('reporting:list', {
        type: 'custom'
      });
      router.route('report/create', 'reporting:create');
      router.route('report/detail/:reportId', 'reporting:detail');
      router.route('report/list/beta', 'reporting:list:beta');
      router.route('board/list', 'board:list');
      router.route('board/create', 'board:create');
      router.route('board/detail/:boardId', 'board:detail');
      router.route('organization/list(/:orgId)', 'organization:list');
      router.route('application/settings', 'setting:all');
      router.route('template/submission', 'template:submission');
      router.route('template/checklist', 'template:checklist');
      router.route('message/template/list(/:tabName)', 'messageTemplate:list');
      router.route('message/template/detail/:messageTemplateId', 'messageTemplate:detail');
      router.route('legacy', 'legacy');
      router.route('logout', 'logout:index');
      RouteHelper.register(router);
      this.app.router = router;
    }
  });
  module.exports = RouteConfigurator;
});

